export const NOTIFICATION_TYPES = {
    DEFAULT: 'NOTIFICATION_TYPES__DEFAULT',
    ACCEPT_DECLINE: 'NOTIFICATION_TYPES__ACCEPT_DECLINE'
};
